import { render, staticRenderFns } from "./Add Load.vue?vue&type=template&id=115ee91a&"
import script from "./Add Load.vue?vue&type=script&lang=js&"
export * from "./Add Load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports